module.exports = __webpack_public_path__ + "static/media/bottom-tear.9904ba57.svg";